export const Page = {
  tag: 'main',
  extends: 'PageTemplate',
  width: '100%',
  maxWidth: 'K_default',
  margin: '- auto',
};